import React from 'react'
import {
  ConsumerSellableReactionRating,
  ConsumerSellableReactionRatingWithDisplayName
} from '#src/generated/graphql'
import classNames from 'classnames'
import styles from './styles.css'
import { Hate, Love, Like } from './reactions'

interface SellableReactionsProps {
  isDisabled?: boolean
  selectedRating?: ConsumerSellableReactionRatingWithDisplayName | null
  onSellableRatingSelected: (reactionType: ConsumerSellableReactionRating) => void
  onProductSkipped?: () => void
}

const SellableReactions: React.SFC<SellableReactionsProps> = ({
  isDisabled,
  onSellableRatingSelected,
  selectedRating,
  onProductSkipped
}) => {
  const sellableRating = selectedRating && selectedRating.rating

  return (
    <div className={styles.ratingsContainer}>
      <button
        disabled={isDisabled}
        className={classNames(styles.ratingButton, {
          [styles.selected]: sellableRating === ConsumerSellableReactionRating.LOVE
        })}
        onClick={() => onSellableRatingSelected(ConsumerSellableReactionRating.LOVE)}
      >
        {sellableRating !== ConsumerSellableReactionRating.LOVE && <Love />}
        Love
      </button>
      <button
        disabled={isDisabled}
        className={classNames(styles.ratingButton, {
          [styles.selected]: sellableRating === ConsumerSellableReactionRating.LIKE
        })}
        onClick={() => onSellableRatingSelected(ConsumerSellableReactionRating.LIKE)}
      >
        {sellableRating !== ConsumerSellableReactionRating.LIKE && <Like />}
        Like
      </button>
      <button
        disabled={isDisabled}
        className={classNames(styles.ratingButton, {
          [styles.selected]: sellableRating === ConsumerSellableReactionRating.DISLIKE
        })}
        onClick={() => onSellableRatingSelected(ConsumerSellableReactionRating.DISLIKE)}
      >
        {sellableRating !== ConsumerSellableReactionRating.DISLIKE && <Hate />}
        Dislike
      </button>
      <button
        disabled={isDisabled}
        className={classNames(styles.ratingButton, {
          [styles.selected]: sellableRating === ConsumerSellableReactionRating.SKIP
        })}
        onClick={() =>
          onProductSkipped
            ? onProductSkipped()
            : onSellableRatingSelected(ConsumerSellableReactionRating.SKIP)
        }
      >
        Skip
      </button>
    </div>
  )
}

export default SellableReactions
